import React from "react";

export function AddressColumnFormatter(cellContent, row) {
  const {city, address} = row.address;
  return (
    <>
      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
        {city}
      </span>
      <span className="text-muted font-weight-bold">
        {address}
      </span>
    </>
  );
}
